<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header text-black p-2">
                        <div class="d-flex justify-content-between align-items-center">
                            <span>Today's Jobs ({{ $dateTimeFormat(new Date(), 'D MMM, YYYY')}})</span>
                            <div class="d-flex gap-1 align-items-center">
                                <div>
                                    <input type="text" class="form-control form-control-sm" placeholder="Search..." v-model="search">
                                </div>
                                <Download
                                    :size="24"
                                    :stroke-width="2"
                                    :class="'text-theme cursor-pointer'"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    data-bs-title="Export to CSV"
                                    @click="exportToCSV"
                                />
                                <MapPinPlus
                                    v-if="displayTodayJobsMap"
                                    :size="24"
                                    :stroke-width="2"
                                    :class="'text-theme cursor-pointer'"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    data-bs-title="Show Map View"
                                    @click="displayTodayJobsMap = !displayTodayJobsMap"
                                />
                                <MapPinOff
                                    v-else
                                    :size="24"
                                    :stroke-width="2"
                                    :class="'text-theme cursor-pointer'"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    data-bs-title="Show List View"
                                    @click="displayTodayJobsMap = !displayTodayJobsMap"
                                />
                                <!-- <button type="button" class="btn btn-sm btn-outline-theme" @click="exportToCSV">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-download-icon lucide-download"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" x2="12" y1="15" y2="3"/></svg>
                                </button>
                                <button type="button" class="btn btn-sm btn-outline-theme" @click="displayTodayJobsMap = !displayTodayJobsMap">
                                    <svg v-if="displayTodayJobsMap" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin-off-icon lucide-map-pin-off"><path d="M12.75 7.09a3 3 0 0 1 2.16 2.16"/><path d="M17.072 17.072c-1.634 2.17-3.527 3.912-4.471 4.727a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 1.432-4.568"/><path d="m2 2 20 20"/><path d="M8.475 2.818A8 8 0 0 1 20 10c0 1.183-.31 2.377-.81 3.533"/><path d="M9.13 9.13a3 3 0 0 0 3.74 3.74"/></svg>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin-plus-icon lucide-map-pin-plus"><path d="M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738"/><circle cx="12" cy="10" r="3"/><path d="M16 18h6"/><path d="M19 15v6"/></svg>
                                </button>-->
                            </div>
                        </div>
                    </div>
                    <div class="card-body overflow-auto p-2" style="height: 200px;">
                        <!-- If there is any job in the list then show the map -->
                        <div v-if="todayJobs.length > 0" v-show="displayTodayJobsMap" class="map-container mb-3" id="map-container">
                            <google-map :orders="todayJobs" map-id="todayJobs" :display="displayTodayJobsMap"></google-map>
                        </div>
                        <div class="table-responsive">
                            <table class="table hm-fs-12 align-middle table-hover table-sm">
                                <thead>
                                    <tr>
                                        <th scope="col" class="bg-theme">Handyman</th>
                                        <th scope="col" class="bg-theme">Client</th>
                                        <th scope="col" class="bg-theme">Address</th>
                                        <th scope="col" class="bg-theme text-center" width="80px">Post Code</th>
                                        <th scope="col" class="bg-theme text-center">Phone</th>
                                        <th scope="col" class="bg-theme text-center">Type</th>
                                        <!-- <th scope="col" class="bg-theme text-center">Action</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="filteredData.length > 0 || filteredProjectUsers.length > 0">
                                        <!-- Display today's jobs -->
                                        <tr
                                            v-for="(job, index) in filteredData"
                                            :key="index"
                                            @click="$goToPage(`/admin/orders/${job.order_number}`)"
                                            class="cursor-pointer"
                                        >
                                            <td class="text-capitalize">
                                                <template v-if="typeof job.order_handymans !== 'undefined' && job.order_handymans.length > 0">
                                                    {{ job.order_handymans.map(handyman => handyman.handyman.first_name).join(', ') }}
                                                </template>
                                            </td>
                                            <td class="text-capitalize">{{ job.first_name }}</td>
                                            <td class="text-capitalize">{{ $truncateString(job.address, 25) }}</td>
                                            <td class="text-uppercase text-center">{{ job.postal_code }}</td>
                                            <td class="text-center">{{ job.phone_number }}</td>
                                            <td class="text-center">Order</td>
                                            <!-- <td class="text-center">
                                                <button class="btn btn-sm btn-theme" @click="gotoPage('/admin/orders/'+job.order_number)">View</button>
                                            </td> -->
                                        </tr>

                                        <!-- Display project users -->
                                        <tr
                                            v-for="(projectUser, index) in filteredProjectUsers"
                                            :key="index"
                                            @click="$goToPage(`/admin/projects/${projectUser?.project?.id}`)"
                                            class="cursor-pointer"
                                        >
                                            <td class="text-capitalize">{{ projectUser?.user?.name }}</td>
                                            <td class="text-capitalize">{{ projectUser?.project?.customer_name }}</td>
                                            <td class="text-capitalize">{{ $truncateString(projectUser?.project?.address, 25) }}</td>
                                            <td class="text-uppercase text-center">{{ projectUser?.project?.postal_code }}</td>
                                            <td class="text-center">{{ projectUser?.project?.customer_phone }}</td>
                                            <td class="text-center">Project</td>
                                            <!-- <td class="text-center">
                                                <button class="btn btn-sm btn-theme" @click="gotoPage('/admin/orders/'+projectUser.order_number)">View</button>
                                            </td> -->
                                        </tr>
                                    </template>
                                    <tr v-else-if="isLoadingTodayJobs">
                                        <td colspan="6" class="text-center">Processing...</td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="6" class="text-center">No job has been added in the system.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import GoogleMap from './../GoogleMap';
import {
    MapPinPlus,
    Download,
    MapPinOff
} from 'lucide-vue-next';

export default {
    name: 'TodayJobs',
    props: {},
    components: {
        GoogleMap,
        MapPinPlus,
        MapPinOff,
        Download
    },
    data() {
        return {
            todayJobs: [],
            projectUsers: [],
            displayTodayJobsMap: false,
            isLoadingTodayJobs: true,
            search: '',
        }
    },
    mounted() {
        this.getTodayJobs();

        this.$emitter.on('refresh-order-list', (data) => {
            this.getTodayJobs();
        });
    },
    computed: {
        filteredData() {
            const query = this.search.toLowerCase();
            return this.todayJobs.filter(job => {
                return job.order_number.toLowerCase().includes(query) ||
                    job.booking_address.toLowerCase().includes(query) ||
                    job.postal_code.toLowerCase().includes(query) ||
                    job.phone_number.toLowerCase().includes(query) ||
                    job.full_name.toLowerCase().includes(query) ||
                    job.email.toLowerCase().includes(query) ||
                    job.phone_number.toLowerCase().includes(query) ||
                    job.contact_person_full_name.toLowerCase().includes(query) ||
                    job.contact_person_phone_number.toLowerCase().includes(query) ||
                    job.order_handymans.map(handyman => handyman.handyman.name).join(', ').toLowerCase().includes(query) ||
                    job.order_items.map(item => item.service_name).join(', ').toLowerCase().includes(query);
            })
        },
        filteredProjectUsers() {
            const query = this.search.toLowerCase();
            return this.projectUsers.filter(projectUser => {
                return projectUser.user.name.toLowerCase().includes(query) ||
                    projectUser.project.name.toLowerCase().includes(query) ||
                    projectUser.project.address.toLowerCase().includes(query) ||
                    projectUser.project.postal_code.toLowerCase().includes(query) ||
                    projectUser.project.customer_phone.toLowerCase().includes(query) ||
                    projectUser.project.customer_name.toLowerCase().includes(query) ||
                    projectUser.project.customer_email.toLowerCase().includes(query);
            })
        }
    },
    methods: {
        getTodayJobs() {
            let self = this;
            axios.post('/admin/dashboard/stats?action=today_jobs', {action: 'today_jobs'})
                .then(response => {
                    // Get order summary
                    self.todayJobs = response.data.orders;
                    self.projectUsers = response.data.projectUsers;
                    self.isLoadingTodayJobs = false;
                })
        },
        exportToCSV() {
            // Export today's jobs to CSV
            // CSV Header
            const headers = [
                'Handyman Name',
                'Client Name',
                'Phone Number',
                'Email',
                'Address',
                'Postal Code',
                'Service Name',
                'Order Number',
                'Order Type'
            ];

            let csv = headers.join(',') + '\n';

            // CSV Data
            // First process orders
            this.filteredData.forEach(job => {
                const row = [
                    `"${job.order_handymans.map(handyman => handyman.handyman.name).join(', ')}"`,
                    `"${job.full_name}"`,
                    `"${job.phone_number}"`,
                    `"${job.email}"`,
                    `"${job.full_address}"`,
                    `"${job.postal_code}"`,
                    `"${job.order_items.map(item => item.service_name).join(', ')}"`,
                    `"${job.order_number}"`,
                    'Order'
                ];
                csv += row.join(',') + '\n';
            });

            // Second process project users
            this.filteredProjectUsers.forEach(projectUser => {
                const row = [
                    `"${projectUser.user.name}"`,
                    `"${projectUser.project.customer_name}"`,
                    `"${projectUser.project.customer_phone}"`,
                    `"${projectUser.project.customer_email}"`,
                    `"${projectUser.project.address}"`,
                    `"${projectUser.project.postal_code}"`,
                    `"${projectUser.description}"`,
                    `"${projectUser.project.name}"`,
                    'Project'
                ];
                csv += row.join(',') + '\n';
            });

            // Create and trigger download
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'today_jobs.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}
</script>
